// Exported for testing
export const RESOLVED = 'resolved';
export const FORBIDDEN = 'forbidden';
export const UNAUTHORIZED = 'unauthorized';
export const NOT_FOUND = 'not_found';

type ORSAccess = 'granted' | 'forbidden' | 'unauthorized';
// Map of status codes to string values
export const getStatus = (statusCode: number, access?: ORSAccess): string => {
	const statusMap = {
		200: RESOLVED,
		401: UNAUTHORIZED,
		403: FORBIDDEN,
		404: NOT_FOUND,
	};

	if (access === FORBIDDEN || access === UNAUTHORIZED) {
		return access;
	}

	return statusMap[statusCode] || 'errored';
};
